<div
  class="card"
  [ngStyle]="{
    background:
      'center / contain no-repeat url(assets/main-game/game-cards/resource-cards-elements/Form/' +
      rarity +
      '.png)'
  }"
  *ngIf="!isPromoCards"
>
  <span [ngStyle]="{ 'font-size': fontSize + 'vw' }">{{ name }}</span>
  <img [src]="element" alt="element" />
  <div class="grade-effect-content">
    <img [src]="grade" alt="grade" />
    <img [src]="effect" alt="effect" />
  </div>
</div>
<video  loop muted inline *ngIf="isPromoCards" (mouseover)="playVideo($event, 'play')"  (mouseleave)="playVideo($event, 'stop')" >
  <source [src]="promoCardImage" type="video/mp4" />
</video>
<div class="quanity" *ngIf="quanity">3</div>
<div class="btn-sell" *ngIf="sellPrice">
  <div class="price-holder">
    {{ sellPrice }}
    <img src="assets/main-game/modals/backpack/ValuteIcon.png" />
  </div>
</div>
